<template>
    <sections class="page-privacy">
        <section-text heading="Privacy Policy" content="<article-privacy />"></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Privacy Policy | ' + $config.public.siteName,
    description: 'Read our privacy policy.',
    index: false,
});
</script>
